import { API } from "../../../legacy/api";
import { LegacyEvent } from "../../../legacy/api";
import { types as AutoplayActionTypes } from "../../containers/AutoplaySettings/Common/AutoplaySettings.actions";
import { types as HeaderTypes } from "../../containers/Header/Common/Header.actions";
import { types as KeypadActionTypes } from "../../containers/Keypad/Common/Keypad.actions";
import { types as MenuActionTypes } from "../../containers/Menu/Common/Menu.actions";
import { types as MoneyTypes } from "../../containers/Money/Money.actions";

export const notifyStateChange = store => next => action => {
  const state = store.getState();
  const result = next(action);
  let event: LegacyEvent = null;
  let value: any = null;

  switch (action.type) {
    case HeaderTypes.TRIGGER_HOME_REQUEST:
      event = "home.request";
      break;
    case HeaderTypes.TRIGGER_PLUGIN_REQUEST:
      event = "plugin.request";
      break;
    case KeypadActionTypes.TRIGGER_VIEW_CHANGE_REQUEST:
      event = "view.changerequest";
      value = action.value;
      break;
    case MoneyTypes.TRIGGER_CHANGE_MONEY_TYPE:
      if (state.money.moneyTypes.length > 1) {
        event = "moneytype.changed";
        value = action.value;
      }
      break;
    case MoneyTypes.TRIGGER_BET_DENOMINATION_CHANGE_REQUEST:
      event = "betdenomination.changerequest";
      value = action.value;
      break;
    case MoneyTypes.TRIGGER_BET_LEVEL_CHANGE_REQUEST:
      event = "betlevel.changerequest";
      value = action.value;
      break;
    case AutoplayActionTypes.TRIGGER_SELECT_ROUNDS_CHANGE_REQUEST:
      event = "autoplay.selectedrounds.changerequest";
      value = action.value;
      break;
    case AutoplayActionTypes.TRIGGER_AUTOPLAY_SETTINGS_RESET_REQUEST:
      event = "autoplay.settings.reset";
      break;
    case AutoplayActionTypes.TRIGGER_UPDATE_ADVANCED_SETTING_CHANGE_REQUEST:
      event = "autoplay.settings.changerequest";
      value = action.value;
      break;
    case KeypadActionTypes.TRIGGER_VOLUME_CHANGE_REQUEST:
      event = "volume.changerequest";
      value = action.value;
      break;
    case KeypadActionTypes.TRIGGER_MUTE_CHANGE_REQUEST:
      event = "mute.changerequest";
      value = action.value;
      break;
    case KeypadActionTypes.TRIGGER_QUICK_SPIN_CHANGE_REQUEST:
      event = "quickspin.changerequest";
      value = action.value;
      break;
    case MenuActionTypes.TRIGGER_SETTING_CHANGE_REQUEST:
      event = "setting.changerequest";
      value = {
        key: action.value.key,
        value: action.value.value
      };
      break;
  }

  if (event) {
    API.notify(event, value);
  }

  return result;
};
